<div class="container-fluid">
  <div class="card" style="max-height:none; min-height:650px;">
    <div class="card-header nocollapse">
      View Questions
    </div>
    <div class="card-header nocollapse bg-info col-md-12 msg-container" *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="d-flex" style="justify-content: space-between;">
      <div class="page-attributes p-1">
        <button type="button" class="btn btn-primary btn-action" (click)="openDeleteModal()" [disabled]="this.questionsToDelete.length<=0" data-toggle="modal" data-target="#deleteQuestionConfirmation"><i class="fa fa-trash"></i> Delete</button>
        <button type="button" class="btn btn-primary btn-action" (click)="unMappedQuestionList()" data-toggle="modal" data-target="#mapQuestionsPopup"><i class="fa fa-map"></i> Map Questions</button>
        <button type="button"
                class="btn btn-primary btn-action dropdown-toggle"
                (click)="toggleQuestionTypes()"
                [attr.aria-expanded]="showQuestionTypes"
                id="dropdownMenuButton">
          Add Question
        </button>
        <div class="dropdown-menu question-types"
             [class.show]="showQuestionTypes"
             aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('matrix')">&nbsp;&nbsp;<i class="fa fa-th"></i>Matrix</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('description')">&nbsp;&nbsp;<i class="fa fa-list-alt"></i>Description</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('textInput')">&nbsp;&nbsp;<i class="fa fa-pencil-square-o"></i>Text Input</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('pickList')">&nbsp;&nbsp;<i class="fa fa-caret-square-o-down"></i>Picklist</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('MCQ')">&nbsp;&nbsp;<i class="fa fa-check-square-o"></i>Multiple Choice</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('MCR')">&nbsp;&nbsp;<i class="fa fa-dot-circle-o"></i>Single Response</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('slider')">&nbsp;&nbsp;<i class="fa fa-sliders"></i>Slider</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('constantsum')">&nbsp;&nbsp;<i class="fa fa-pencil-square-o"></i>Constant Sum</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('rankingsort')">&nbsp;&nbsp;<i class="fa fa-reorder"></i>Ranking Sort</a>
          <a class="dropdown-item anchor-cursor" (click)="redirectMenu('datetime')">&nbsp;&nbsp;<i class="fa fa-calendar"></i>Date Picker</a>
        </div>
      </div>
      <div class="p-1"><button type="button" class="btn btn-primary btn-action pull-right mb-0 me-2" (click)="BackUrl()" style="margin-top:7px;"><i class="fa fa-arrow-left"></i> Back</button></div>
    </div>
    <div style="padding:0 11px">
      <div class="bg-info p-1">
        <div class="col-md-5"><span><b>Folder Name : </b>{{ question }}</span></div>
        <!--<div class="col-md-7"><button type="button" class="btn btn-primary btn-action pull-right" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button></div>-->
      </div>
      <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
      <isg-grid [rowData]="mainQuestionList"
                [columnDefs]="columnDefs"
                [config]="mainGridConfig"
                (rowSelected)="onRowChecked($event)"
                (gridReady)="onFolderGridReady($event)">
      </isg-grid>
    </div>
    <div *ngIf="showDeleteModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delete Question/Folder Confirmation</h5>
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete the selected question(s)/folder(s)?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal" data-dismiss="modal"><i class="fa fa-times"></i> Close</button>
            <button type="button" class="btn btn-danger btn-modal" data-dismiss="modal" (click)="deleteQuestions()"><i class="fa fa-trash"></i> Delete</button>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="modal fade" id="mapQuestionsPopup" tabindex="-1" role="dialog" aria-labelledby="createSectionModel" aria-hidden="true">-->
    <div *ngIf="showMappingModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Map Questions To Folder</h5>
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="CloseModal()"></button>
          </div>
          <div class="modal-body">
            <form [formGroup]="mapQuestionForm" #f="ngForm">
              <div class="alert alert-info" *ngIf="successOrFailureMessage!==''">
                <i class="fa fa-info-circle"></i> {{successOrFailureMessage}}
              </div>
              <div class="alert alert-secondary mb-3">
                <b>Folder Name:</b> {{ question }}
              </div>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-control-label" for="folderId">By Folder</label>
                  <select class="form-control" id="folderId" name="folderId" formControlName="folderId" (change)="loadQuestionByFolder()">
                    <option *ngFor="let folder of folderList" [ngValue]="folder?.folderId">
                      {{folder.folderName}}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label" for="questionCategoryId">By Category</label>
                  <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control" (change)="onQuestionCategoryChange()">
                    <option value="" selected>--Select--</option>
                    <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="mapQuestionForm.get('questionCategoryId')?.value==item?.questionCategoryId">
                      {{item.questionCategoryName}}
                    </option>
                  </select>
                </div>
              </div>
              <!-- Using IsgGridComponent for consistent styling -->
              <isg-grid [rowData]="questionList"
                        [columnDefs]="colDefForUnmappingQuestions"
                        [config]="mapQuestionsGridConfig"
                        (rowSelected)="onRowCheckedMapQuestion($event)"
                        (gridReady)="unmappedQuestionGrid($event)">
              </isg-grid>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal" data-dismiss="modal"><i class="fa fa-times" (click)="CloseModal()"></i> Close</button>
            <button type="button" class="btn btn-primary btn-modal" (click)="mapQuestionsToFolderGrid()" [disabled]="this.mapQuestionsRowSelect.length<=0"><i class="fa fa-map-o"></i> Map Questions</button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="showCopyModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Copy Question</h5>
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="CloseModal()"></button>
          </div>
          <form [formGroup]="copyQuestionForm" #f="ngForm">
            <div class="modal-body">
              <div class="alert alert-info mb-3">
                <b>Source Question:</b> {{currentSelectedQuestionName}}
              </div>
              <div class="row align-items-center">
                <label for="question" class="form-control-label col-md-4">New Question</label>
                <div class="col-md-8">
                  <input type="text" name="question" id="question" formControlName="question" class="form-control" placeholder="Enter question name" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal" data-dismiss="modal" (click)="CloseModal()"><i class="fa fa-times"></i> Close</button>
              <button type="button" class="btn btn-primary btn-modal" [disabled]="!copyQuestionForm.valid" data-dismiss="modal" (click)="CopyQuestion()"><i class="fa fa-copy"></i> Copy</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>
